import React, { useRef } from "react";
import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import OrganisationSettingActions from "../../Actions/OrganisationSettingActions";
import commonUtils from "../../helpers/commonUtils";
import { AiOutlineEdit } from "react-icons/ai";
import { Button } from "@mui/material";
import { useLanguageContext } from "../../Context/LanguageContext";
import organisationSettingStore from "../../Stores/OrganisationSettingStore";
import organisationSettingConstants from "../../Constants/OrganisationSettingConstants";
import { useGlobalSpinnerActionsContext } from "../../Context/GlobalSpinnerContext";
import EditSettingPopUp from "./EditSettingPopUp";
import { useThemeActionsContext } from "../../Context/ThemeContext";
import { useSelectedConfigActionContext } from "../../Context/GlobalContext";
import CustomDataGrid from "../ReusableComponent/DataGrid/CustomizeDataGrid";
import { PageHeader } from "../MuiOverRideComponent/PageHeader";
import { GridActionsCellItem } from "@mui/x-data-grid-pro";
import { render } from "@testing-library/react";
const OrganisationSettings = () => {
  const [organisationSettingsList, setOrganisationSettingsList] = useState([]);
  const [settingDetails, setSettingDetails] = useState({});
  const { localization } = useLanguageContext();
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const updateTheme = useThemeActionsContext();
  const themeRef = useRef("");
  const updateSelectedConfig = useSelectedConfigActionContext();
  const columns = [
    {
      field: "displayText",
      headerName: localization.settingName,
      hideable: false,
    },
    {
      field: "actions",
      type: "actions",
      width: 45,
      hideable: false,
      headerName: localization.actions,
      getActions: (params) => [...getAction(params, localization)],
    },
    {
      field: "value",
      renderCell: (params) => {
        console.log("params", params);
        if (params.row.options && params.row.options.length > 0) {
          return (
            params.row.options.find(
              (option) => option.value == params.row.value,
            )?.text || params.row.value
          );
        } else {
          return params.row.value;
        }
      },
      headerName: localization.settingValue,
    },
  ];

  const getOrganisationSetting = () => {
    setGlobalSpinner(true);
    OrganisationSettingActions.getOrganisationSettings();
  };

  useEffect(() => {
    getOrganisationSetting();
    function getOrgSettingSuccess() {
      var res = organisationSettingStore.getOrgSettingResult();

      if (res.length > 0) {
        let temp = res.map((row, index) => {
          row.id = index;
          return row;
        });
        setOrganisationSettingsList(temp);
      } else {
        setOrganisationSettingsList([]);
      }
      setGlobalSpinner(false);
      updateSelectedConfig("");
    }

    function getOrgSettingFailure() {
      setGlobalSpinner(false);
      updateSelectedConfig("");
    }

    organisationSettingStore.addChangeListener(
      organisationSettingConstants.GET_ORG_SETTING_SUCCESS,
      getOrgSettingSuccess,
    );

    organisationSettingStore.addChangeListener(
      organisationSettingConstants.GET_ORG_SETTING_FAILURE,
      getOrgSettingFailure,
    );

    return () => {
      organisationSettingStore.removeChangeListener(
        organisationSettingConstants.GET_ORG_SETTING_SUCCESS,
        getOrgSettingSuccess,
      );

      organisationSettingStore.removeChangeListener(
        organisationSettingConstants.GET_ORG_SETTING_FAILURE,
        getOrgSettingFailure,
      );
    };
  }, []);

  useEffect(() => {
    function getOrgSettingUpdateSuccess() {
      var res = organisationSettingStore.getOrgSettingUpdateResult();

      if (res) {
        toast.success(localization.settingUpdatedSuccess);
        commonUtils.hideModalPopUp("editOrganisationSettingModalClose");
        updateTheme(themeRef.current);
        getOrganisationSetting();
      }
      setGlobalSpinner(false);
    }

    function getOrgSettingUpdateFailure() {
      var res = organisationSettingStore.getOrgSettingUpdateResult();

      if (res) {
        toast.error(res);
      }
      setGlobalSpinner(false);
    }

    organisationSettingStore.addChangeListener(
      organisationSettingConstants.UPDATE_ORG_SETTING_SUCCESS,
      getOrgSettingUpdateSuccess,
    );

    organisationSettingStore.addChangeListener(
      organisationSettingConstants.UPDATE_ORG_SETTING_FAILURE,
      getOrgSettingUpdateFailure,
    );

    return () => {
      organisationSettingStore.removeChangeListener(
        organisationSettingConstants.UPDATE_ORG_SETTING_SUCCESS,
        getOrgSettingUpdateSuccess,
      );

      organisationSettingStore.removeChangeListener(
        organisationSettingConstants.UPDATE_ORG_SETTING_FAILURE,
        getOrgSettingUpdateFailure,
      );
    };
  }, [localization]);

  function getAction(params) {
    const _acionList = [];

    if (
      !(
        (params.row.settingName == "DateFormat" && params.row.value != "") ||
        (params.row.settingName == "MultiplePruefPlansAllowed" &&
          params.row.value.toLowerCase() === "Yes".toLowerCase())
      )
    ) {
      _acionList.push(
        <GridActionsCellItem
          label={localization.toolTipEdit}
          showInMenu
          data-toggle="modal"
          onClick={() => {
            setCurrentSettingDetails(params.row);
          }}
          data-target="#editOrganisationSetting"
        />,
      );
    }

    return _acionList;
  }
  function updateSelectedTheme(selectedTheme) {
    themeRef.current = selectedTheme;
  }

  const closeEditOrganisationSettingPopUpCallback = () => {
    setSettingDetails("");
  };

  const setCurrentSettingDetails = (row) => {
    setSettingDetails(row);
  };

  const operations = {
    // RowOperationList: [
    //   {
    //     label: "Edit",
    //     component: <RenderEditButton />,
    //     onClick: setCurrentSettingDetails,
    //     condition: {
    //       handleMethod: (row) =>
    //         !(
    //           (row.settingName == "DateFormat" && row.value != "") ||
    //           (row.settingName == "MultiplePruefPlansAllowed" &&
    //             row.value.toLowerCase() === "Yes".toLowerCase())
    //         ),
    //     },
    //   },
    // ],
    GridToolBarAction: [],
  };

  return (
    <>
      <div
        id="content"
        style={{ height: "100%", width: "100%", overflow: "auto" }}
      >
        {organisationSettingsList && (
          <CustomDataGrid
            Title={localization.orgSetting + " / " + localization.settings}
            columns={columns}
            rows={organisationSettingsList}
            operations={operations}
            onAdd={() => {}}
            showExport={true}
            showColumns={true}
            showFilters={true}
            showDensity={true}
            visibleColumns={["displayText", "value"]}
            showCheckBox={false}
            gridTableHeight={"dataGridLarge"}
          />
        )}
      </div>
      <EditSettingPopUp
        settingDetails={settingDetails}
        updateTheme={updateSelectedTheme}
        closeEditOrganisationSettingPopUpCallback={
          closeEditOrganisationSettingPopUpCallback
        }
      />
    </>
  );
};

export default OrganisationSettings;
